import * as config from './config'
import { type SendMessageResponse, type GrammarCheckResult, type GetTranslationResponse, type ListConversationsResponse, type StartChatRequest, type StartChatResponse, type GetDefaultsResponse, type GetTranslationInput, type TranslationDumpSnapshot } from './model'

export const sendMessage = async (conversationId: string, message: string): Promise<SendMessageResponse> => {
  return await httpPost<SendMessageResponse>(`${config.default.api.URL}/v1/ula/chat/send`, {
    conversationId,
    lastMessageId: '',
    message
  })
}

export const requestGrammarCheck = async (conversationId: string, message: string, messageId: string): Promise<GrammarCheckResult> => {
  return await httpPost<GrammarCheckResult>(`${config.default.api.URL}/v1/ula/chat/grammar-check`, {
    conversationId,
    message,
    messageId
  })
}

export const getTranslation = async (request: GetTranslationInput): Promise<GetTranslationResponse> => {
  return await httpPost<GetTranslationResponse>(`${config.default.api.URL}/v1/ula/translate/get`, request)
}

export const listConversations = async (): Promise<ListConversationsResponse> => {
  return await httpPost<ListConversationsResponse>(`${config.default.api.URL}/v1/ula/chat/list`)
}

export const startChat = async (request: StartChatRequest): Promise<StartChatResponse> => {
  return await httpPost<StartChatResponse>(`${config.default.api.URL}/v1/ula/chat/start`, request)
}

export const getDefaults = async (): Promise<GetDefaultsResponse> => {
  return await httpPost<GetDefaultsResponse>(`${config.default.api.URL}/v1/ula/settings-get`, {})
}

export const saveDefaults = async (defaults: GetDefaultsResponse): Promise<unknown> => {
  return await httpPostText201(`${config.default.api.URL}/v1/ula/settings-update`, { defaults })
}

export const computeDump = async (): Promise<unknown> => {
  return await httpPostText(`${config.default.api.URL}/v1/ula/settings/create-translation-dump`, {})
}

export const getDump = async (): Promise<TranslationDumpSnapshot> => {
  return await httpGet<TranslationDumpSnapshot>(`${config.default.api.URL}/v1/ula/settings/get-translation-dump`)
}

export const postHowDoISay = async (message: string, defaults: GetDefaultsResponse): Promise<StartChatResponse> => {
  return await httpPost<StartChatResponse>(`${config.default.api.URL}/v1/ula/how-do-i-say`, { phrase: message, defaults: defaults })
}

const httpPostText201 = async (url: string, jsonBodyObject?: any): Promise<string> => {
  let response
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('cognito') ?? ''
      },
      redirect: 'follow',
      body: JSON.stringify(jsonBodyObject || {})
    })
  } catch (e) {
    return await Promise.reject(new Error(`Unable to POST ${url}:  ${String(e)}`))
  }
  if (response.status !== 201) {
    return await Promise.reject(new Error(`Non 201 status: ${response.status}`))
  }
  return await response.text()
}


const httpPostText = async (url: string, jsonBodyObject?: any): Promise<string> => {
  let response
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('cognito') ?? ''
      },
      redirect: 'follow',
      body: JSON.stringify(jsonBodyObject || {})
    })
  } catch (e) {
    return await Promise.reject(new Error(`Unable to POST ${url}:  ${String(e)}`))
  }
  if (response.status !== 200) {
    return await Promise.reject(new Error(`Non 200 status: ${response.status}`))
  }
  return await response.text()
}

const httpPost = async<T>(url: string, jsonBodyObject?: any): Promise<T> => {
  let response
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('cognito') ?? ''
      },
      redirect: 'follow',
      body: JSON.stringify(jsonBodyObject || {})
    })
  } catch (e) {
    return await Promise.reject(new Error(`Unable to POST ${url}:  ${String(e)}`))
  }
  if (response.status !== 200) {
    return await Promise.reject(new Error(`Non 200 status: ${response.status}`))
  }
  const respJson = await response.json() as T
  return respJson
}

const httpGet = async<T>(url: string): Promise<T> => {
  let response
  try {
    response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('cognito') ?? ''
      },
      redirect: 'follow'
    })
  } catch (e) {
    return await Promise.reject(new Error(`Unable to GET ${url}:  ${String(e)}`))
  }
  if (response.status !== 200) {
    return await Promise.reject(new Error(`Non 200 status: ${response.status}`))
  }
  const respJson = await response.json() as T
  return respJson
}

export function inRange(number: number, arr: number[]): boolean {
  return number >= arr[0] && number <= arr[1]
}
